import type { WidgetType } from '@/types'

const WIDGETS_SETTINGS: Record<
  WidgetType,
  { class?: string; header: string; color?: string }
> = {
  CelebrationWidget: {
    header: 'Celebration',
    color: '#ff607f'
  },
  BoardingAnnouncementWidget: {
    header: 'Boarding Announcement',
    color: '#fd8f5e'
  },
  PosterWidget: {
    header: 'Poster',
    color: '#0da591'
  },
  EventAgendaWidget: {
    header: 'Event Agenda',
    color: '#5965ef'
  },
  StudentArtGalleryWidget: {
    class: 'student-art-gallery',
    header: 'Student Art Gallery',
    color: '#ffffff'
  },
  CongratulationsWidget: {
    header: 'Congratulations',
    color: '#ffffff'
  },
  JournalWidget: {
    header: 'Rosenberg Journal',
    color: '#ebcfcf'
  },
  MenuWidget: {
    header: 'Dining Hall',
    color: '#00ac69'
  },
  StudentsPicWidget: {
    header: 'Student Pics',
    color: '#ffffff'
  },
  MysteryLinkWidget: {
    header: 'Mystery Link',
    color: '#9561E8'
  },
  StudentsAnnouncementWidget: {
    header: 'Student Announcement',
    color: '#ffffff'
  },
  InfoWithVideoWidget: {
    header: 'Info'
  },
  EventInfoWithPhotoWidget: {
    header: 'Event Info'
  },
  EventInfoWidget: {
    header: 'Event Info'
  },
  VariantManualCongratulationsWidget: {
    header: 'Congratulations',
    color: '#ffffff'
  },
  ClockWidget: {
    header: '',
    color: ''
  }
}

export default WIDGETS_SETTINGS
